import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=658483bc&scoped=true&"
import script from "./ios.vue?vue&type=script&lang=ts&"
export * from "./ios.vue?vue&type=script&lang=ts&"
import style0 from "./ios.vue?vue&type=style&index=0&id=658483bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658483bc",
  null
  
)

export default component.exports